import React from "react";
import Icon from "@ant-design/icons";

const RefreshIconSvg = ({ width = "1rem", height = "1rem", fill = "none" }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox={`0 0 ${width} ${height}`}
		height={height}
		width={width}
		fill={fill}
	>
		<path
			d="M9.3461 5.4534H12.2584V5.45236M1.74023 11.4594V8.54701M1.74023 8.54701L4.65261 8.54701M1.74023 8.54701L3.59576 10.4037C4.17356 10.9826 4.90684 11.4218 5.7537 11.6487C8.321 12.3366 10.9599 10.8131 11.6478 8.24578M2.35075 5.75465C3.03866 3.18735 5.67753 1.66379 8.24483 2.3517C9.09169 2.57862 9.82498 3.01782 10.4028 3.59671L12.2584 5.45236M12.2584 2.54105V5.45236"
			stroke="white"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
const RefreshIcon = (props) => (
	<Icon component={() => <RefreshIconSvg {...props} />} />
);

export default RefreshIcon;
